import {useMemo, useState} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {ConditioningsColumns} from './columns/_columns'
import {Conditionings} from '../core/_models'
import {ConditioningsListLoading} from '../components/loading/ConditioningsListLoading'
import {ConditioningsListPagination} from '../components/pagination/ConditioningsListPagination'
// import axios from 'axios'
import {useIntl} from 'react-intl'
import {KTCardBody} from '../../../../../../../../../../_metronic/helpers'
import {Link, useParams} from 'react-router-dom'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || 'api'

const ConditioningsTable = () => {
  const intl = useIntl()
  const Conditionings = useQueryResponseData()
  const {uuid, id} = useParams()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => Conditionings, [Conditionings])
  const columns = useMemo(() => ConditioningsColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  const [loading, setLoading] = useState(false)
  const [link, setLink] = useState<any>()

  async function reportConditions() {
    setLoading(true)
    try {
      const {data} = await axios.get(`${API_URL}/sga/v1/conditionings/compliance_report/${uuid}`)
      setLink(data)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
    setLoading(false)
  }
  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <div className='d-flex justify-content-end mb-3'>
          {/* <button type='button' className='btn btn-light-primary btn-sm me-3'>
            <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
            {intl.formatMessage({id: 'COMMON.BUTTON.EXPORT'})}
          </button> */}

          <button
            type='button'
            className='btn btn-sm btn-success me-3'
            disabled={loading}
            onClick={reportConditions}
            formTarget='_blank'
          >
            {loading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                {intl.formatMessage({id: 'COMMON.GENERATING_REPORT_BUTTON'})}{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              'Gerar Relatório'
            )}
            {link && <iframe src={link} className='d-none'></iframe>}
          </button>

          <Link to={`/addConditioning/${id}/${uuid}`}>
            <button type='button' className='btn btn-sm btn-primary'>
              <i className='bi bi-plus fs-3'></i>
              {intl.formatMessage({id: 'MENU.CONDITIONING'})}
            </button>
          </Link>
        </div>

        <table
          id='kt_table_conditionings'
          className='table align-middle table-row-dashed fs-6  dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Conditionings>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Conditionings>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={10}>
                  <div className='d-flex text-center fs-7 w-100 align-content-center justify-content-center'>
                    {intl.formatMessage({id: 'COMMON.MSG.NOT_FOUND_DATA'})}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ConditioningsListPagination />
      {isLoading && <ConditioningsListLoading />}
    </KTCardBody>
  )
}

export {ConditioningsTable}
